// src/shared/collectClientSignals.js
export async function collectClientSignals() {
  const nav = navigator || {};
  const scr = window.screen || {};
  const tz = Intl?.DateTimeFormat?.().resolvedOptions?.().timeZone || null;

  return {
    ua: nav.userAgent || null,
    lang: nav.language || null,
    tz,
    screen: {
      w: scr.width || null,
      h: scr.height || null,
      dpr: window.devicePixelRatio || null,
    },
    hw: {
      cores: nav.hardwareConcurrency ?? null,
      touch: nav.maxTouchPoints ?? 0,
    },
  };
}
